import { render, staticRenderFns } from "./SendSurveyDialog.vue?vue&type=template&id=9923e228&scoped=true&"
import script from "./SendSurveyDialog.vue?vue&type=script&lang=ts&"
export * from "./SendSurveyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SendSurveyDialog.vue?vue&type=style&index=0&id=9923e228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923e228",
  null
  
)

export default component.exports